module.exports = __webpack_public_path__ + "media/images/gba/2019/v2/sg/sg_b_una_tinta-f4b18a602e27534103bbb16f16602907.svg";